var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "matrix(20.1024 0 0 20.1024 -11.3129 -11.331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 16.25c1.795 0 3.25-1.455 3.25-3.25s-1.455-3.25-3.25-3.25-3.25 1.455-3.25 3.25 1.455 3.25 3.25 3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.926 12.116c-1.344-2.078-3.087-3.843-5.042-5.105-2.161-1.397-4.548-2.136-6.901-2.136-2.16 0-4.283.617-6.311 1.834-2.068 1.24-3.942 3.053-5.57 5.386-.183.264-.284.576-.29.898-.006.321.084.637.258.907 1.341 2.099 3.067 3.866 4.991 5.111 2.166 1.403 4.496 2.114 6.922 2.114 2.372 0 4.764-.733 6.916-2.119 1.953-1.257 3.693-3.029 5.032-5.124.168-.264.257-.571.256-.884s-.092-.619-.261-.882zm-11.926 5.759c-.964 0-1.907-.286-2.708-.822-.802-.535-1.427-1.297-1.796-2.187-.369-.891-.465-1.871-.277-2.817s.652-1.814 1.334-2.496 1.55-1.146 2.496-1.334 1.926-.092 2.817.277c.89.369 1.652.994 2.187 1.796.536.801.822 1.744.822 2.708-.001 1.293-.516 2.532-1.429 3.446-.914.913-2.153 1.428-3.446 1.429z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye.2bc34d35ee6cd9323bb28da414975d91.svg";